// Plain module so server components can build sign-up links too.

export type LandingPlanTier = 'free' | 'starter' | 'pro';
export type LandingBillingCycle = 'monthly' | 'yearly';

/** Build a signup URL with plan/billing params (for use in Link href). */
export function getSignupUrl({
  plan = 'starter',
  billingCycle = 'monthly',
}: { plan?: LandingPlanTier; billingCycle?: LandingBillingCycle } = {}) {
  const redirectUrl =
    plan === 'free'
      ? '/onboarding?plan=free'
      : `/onboarding?plan=${plan}&billing=${billingCycle}`;
  return `/sign-up?redirect_url=${encodeURIComponent(redirectUrl)}`;
}
